import api from '../../lib/api';

export const addTask = data =>
  function get(dispatch) {
    api
      .sendPost('/public-dashboard/action/task', data, (error, response) => {
        if (error) return console.error(error);
        dispatch(addTaskSuccess(response.data));
        return dispatch(getTasks());
      });
  };

export const deleteTask = taskId =>
  function get(dispatch) {
    api
      .sendDelete(`/public-dashboard/action/task/${taskId}`, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getTasks());
      });
  };

export const updateTask = data =>
  function get(dispatch) {
    api
      .sendPut(`/public-dashboard/action/task/${data.id}`, data, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getTasks());
      });
  };
export const completeTask = taskId =>
  function get(dispatch) {
    api
      .sendPut(`/public-dashboard/action/task/${taskId}`, { status: 'completed' }, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getTasks());
      });
  };

export const clearCompleted = () =>
  function get(dispatch) {
    api
      .sendPost('/public-dashboard/action/task/clear-completed', {}, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getTasks());
      });
  };

export const getTasks = filter =>
  function get(dispatch) {
    api
      .sendGet(`/public-dashboard/action/task?filter=${filter}`, (error, response) => {
        if (error) return console.error(error);
        return dispatch(getTasksSuccess(response.data.data));
      });
  };

export const changeFilter = filter =>
  function get(dispatch) {
    dispatch({
      type: 'UPDATE_FILTER_SUCCESS',
      filter,
    });
    dispatch(getTasks(filter));
  };

export const getTasksSuccess = data => ({
  type: 'GET_TASKS_SUCCESS',
  data,
});

export const addTaskSuccess = data => ({
  type: 'CREATE_TASK_SUCCESS',
  data,
});



// WEBPACK FOOTER //
// ./src/Actions/Dashboard/task.js